module.exports = __webpack_public_path__ + "img/trunk_7x1.92145e96.svg";